<template>
  <v-file-input
      :rules="rules"
      accept="image/png, image/jpeg, .pdf"
      :label="label"
      variant="solo"
      @update:modelValue="onImageChange"
      counter
      multiple
      chips
      :class="obligatorio ? 'asterisco' : ''"
      @click:clear="eliminarImagenes"
      :prepend-icon="false"
      :model-value="imagenes ? imagenesTitle : []"
      :readonly="readonly"
      :clearable="!readonly"
  >
    <template #message="{ message }">
      <div class="error-message-red">
        <span>{{ message }}</span>
      </div>
    </template>
  </v-file-input>
</template>

<style src="../assets/general.css"></style>

<script>

  export default {
    name: 'ImageInput',
    props: {
      imagenes: {
        type: Array,
        default: () => [],
      },
      maxImages: {
        type: Number,
        default: 5,
      },
      maxSize: {
        type: Number,
        default: 2500000,
      },
      obligatorio: {
        type: Boolean,
        default: false,
      },
      nombreImagen: {
        type: String,
        default: null,
      },
      pisable:{
        type: Boolean,
        default: true,
      },
      label: {
        type: String,
        default: 'Subir archivo',
      },
      tipoDocumentacion: {
        type: Number,
        default: 0,
      },
      readonly: {
        type: Boolean,
        default: false,
      },
    },
    data: () => ({
      images: []
    }),
    computed: {
      rules() {
        return [
          value => {
            if (this.obligatorio && (!value || value.length === 0)) {
              return 'Se requiere ingresar al menos un archivo.';
            }
            if (value && value.length > this.maxImages) {
              return `No se pueden subir más de ${this.maxImages} imágenes.`;
            }
            if (value && value.some(file => file.size > this.maxSize)) {
              return `El tamaño máximo permitido es de ${this.maxSize / 1000000} MB.`;
            }
            if (value && value.some(file => !['image/png', 'image/jpeg', 'application/pdf'].includes(file.type))) {
              return 'Solo se permiten archivos PNG, JPEG y PDF.';
            }
            return true;
          },
        ];
      },
      imagenesTitle(){
        return this.imagenes.map(img => 
        {
          const blob = new Blob([img.contenidoBase64], {type: img.tipoMime});
          return new File([blob], img.nombre, {type: img.tipoMime});
        });
      }
    },
    methods: {
      onImageChange(files) {
        let newImages = [];
        const promises = Array.from(files).map((file) => {
          return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = () => {
              const image ={
                nombre: this.nombreImagen ? this.nombreImagen+file.name : file.name,
                tipoMime: file.type,
                contenidoBase64: reader.result.split(',')[1],
                id: `${Date.now()}-${file.name}`,
                tipoDocumentacion: this.tipoDocumentacion,
              };
              newImages.push(image);
              this.images.push(image);
              resolve();
            };
            reader.readAsDataURL(file);
          });
        });

        Promise.all(promises).then(() => {
          if(this.pisable){
            this.$emit('update:imagenes', newImages);
          }
          else{
            this.$emit('update:imagenes', [...this.imagenes, ...newImages]);
          }
        });
      },
      eliminarImagenes() {
        const idsToRemove = this.images.map(img => img.id); // Collect IDs of images in this instance
        const updatedImages = this.imagenes.filter(img => !idsToRemove.includes(img.id)); // Remove matching images

        this.$emit('update:imagenes', updatedImages); // Update global list
        this.images = []; // Clear local list of images
      }
    },
  }
</script>